import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {environment} from 'environment';
import {AuthRequest} from 'shared/auth-request/auth-request';

import {Badge} from '../model/model';

@Injectable()
export class BadgeRepository {

  constructor(
    private http: HttpClient,
    private authRequest: AuthRequest,
  ) { }

  public getBadges(): Observable<Array<Badge>> {
    return this.authRequest.handleRequest(
      this.http.get<Array<Badge>>(environment.badge.badgeRoute, {withCredentials: true}));
  }

  public calculateNewBadges(): Observable<number> {
    return this.authRequest.handleRequest(
      this.http.get<number>(environment.badge.calculateNewBadgesRoute, {withCredentials: true}));
  }

}
